/**
 * Post add-to-cart add-ons popup (metafield: custom.addons).
 * Intercepts #AddToCartForm when #product-addons-popup is present.
 */
(function ($) {
  'use strict';

  var $popup = $('#product-addons-popup');
  if (!$popup.length) {
    return;
  }

  var configEl = document.getElementById('product-addons-config');
  var config = configEl ? JSON.parse(configEl.textContent) : {};
  var $form = $('#AddToCartForm');
  var $addToCart = $('#AddToCart');
  var addLabel = $addToCart.find('#AddToCartText').text() || 'Add to cart';
  var addingLabel = 'Adding...';
  var carouselInitialized = false;
  var addonsAddedCount = 0;

  function getAddonLineProperties() {
    var properties = {};

    $form.serializeArray().forEach(function (field) {
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (!match) {
        return;
      }

      var key = match[1];
      if (key === 'Message') {
        return;
      }

      properties[key] = field.value;
    });

    return properties;
  }

  function updateDismissButton() {
    var $dismiss = $popup.find('[data-addons-dismiss]');
    if (!$dismiss.length) {
      return;
    }

    if (addonsAddedCount > 0) {
      $dismiss.text(config.continueText || 'Continue to cart');
      $dismiss.addClass('product-addons__dismiss--continue');
    } else {
      $dismiss.text(config.dismissText || 'No thanks');
      $dismiss.removeClass('product-addons__dismiss--continue');
    }
  }

  function markAddonAdded($btn) {
    var $label = $btn.find('[data-addon-add-text]');
    $btn
      .prop('disabled', true)
      .addClass('product-addon-item__add--added')
      .attr('aria-disabled', 'true');
    $label.text(config.addedLabel || 'Added');

    addonsAddedCount += 1;
    updateDismissButton();
  }

  function resetPopupAddonState() {
    addonsAddedCount = 0;
    $popup.find('[data-addon-add]').each(function () {
      var $btn = $(this);
      var $label = $btn.find('[data-addon-add-text]');
      var defaultLabel = $label.data('default-label') || 'Add to cart';

      $btn
        .prop('disabled', false)
        .removeClass('product-addon-item__add--added')
        .removeAttr('aria-disabled');
      $label.text(defaultLabel);
    });
    updateDismissButton();
  }

  function parseDeliveryDate() {
    var $dayDelivery = $('#day_delivery');
    var raw = ($dayDelivery.val() || '').trim();
    if (!raw) {
      return null;
    }

    if ($dayDelivery.datepicker) {
      try {
        var dpDate = $dayDelivery.datepicker('getDate');
        if (dpDate && !isNaN(dpDate.getTime())) {
          return dpDate;
        }
      } catch (e) {
        /* datepicker not initialised */
      }
    }

    if (typeof dayjs === 'function') {
      var parts = raw.split('/');
      if (parts.length === 3) {
        var parsed = dayjs(
          parts[2] + '-' + parts[1] + '-' + parts[0]
        ).startOf('day');
        if (parsed.isValid()) {
          return parsed.toDate();
        }
      }
    }

    if (typeof moment === 'function') {
      var m = moment(raw, 'DD/MM/YYYY', true);
      if (m.isValid()) {
        return m.toDate();
      }
    }

    return null;
  }

  function showDeliveryDateError() {
    var $dayDelivery = $('#day_delivery');
    $('#invalid_date_message').show();
    $addToCart.removeClass('is-added').removeClass('is-adding');
    if ($dayDelivery.datepicker) {
      $dayDelivery.datepicker('show');
    }
    setTimeout(function () {
      var el = document.getElementById('delivery-postcode');
      if (el) {
        el.focus();
        var len = el.value.length;
        el.setSelectionRange(len, len);
      }
    }, 200);
  }

  function validateDeliveryDate() {
    var $dayDelivery = $('#day_delivery');
    if (!$dayDelivery.length) {
      return true;
    }

    var deliveryDate = parseDeliveryDate();
    if (!deliveryDate || isNaN(deliveryDate.getTime())) {
      showDeliveryDateError();
      return false;
    }

    // New shipping rules use checkDateEligibility in the datepicker; skip legacy restrictedDays.
    if (!window.DeliveryConfigs && typeof restrictedDays === 'function' && !restrictedDays(deliveryDate)) {
      showDeliveryDateError();
      return false;
    }

    $('#invalid_date_message').hide();
    return true;
  }

  function setAddToCartLabel(text) {
    $addToCart.find('#AddToCartText').text(text);
  }

  function updateCartCount() {
    $.getJSON('/cart.js', function (cart) {
      var selectors = '#CartCount, #CartDrawerCount';
      $(selectors).each(function () {
        var $el = $(this);
        if ($el.length) {
          $el.html(cart.item_count).removeClass('hidden-count');
        }
      });
      var $cost = $('#CartCost');
      if ($cost.length && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        $cost.html(Shopify.formatMoney(cart.total_price, config.moneyFormat));
      }
    });
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function initAddonsCarousel() {
    var $carousel = $popup.find('.product-addons__carousel');
    if (!$carousel.length || typeof $.fn.owlCarousel !== 'function') {
      return;
    }

    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel');
      $carousel.removeClass('owl-loaded owl-hidden');
    }

    var itemCount = $carousel.children('.product-addon-item').length;

    var $wrap = $carousel.closest('.product-addons-popup__carousel-wrap');
    var $prev = $wrap.find('[data-addons-carousel-prev]');
    var $next = $wrap.find('[data-addons-carousel-next]');

    function updateNavVisibility() {
      var owl = $carousel.data('owl.carousel');
      var visibleItems = owl ? owl.settings.items : 2;
      var showNav = itemCount > visibleItems;

      $prev.toggle(showNav);
      $next.toggle(showNav);
    }

    $carousel.owlCarousel({
      loop: false,
      margin: 12,
      nav: false,
      dots: false,
      rewind: true,
      responsive: {
        0: {
          items: 2,
          margin: 10
        },
        993: {
          items: 4,
          margin: 12
        }
      }
    });

    $prev.off('click.addonsNav').on('click.addonsNav', function () {
      $carousel.trigger('prev.owl.carousel');
    });
    $next.off('click.addonsNav').on('click.addonsNav', function () {
      $carousel.trigger('next.owl.carousel');
    });

    $carousel
      .off('initialized.owl.carousel.addons resized.owl.carousel.addons')
      .on('initialized.owl.carousel.addons resized.owl.carousel.addons', updateNavVisibility);

    updateNavVisibility();

    carouselInitialized = true;
  }

  function openAddonsPopup() {
    resetPopupAddonState();

    var successText = $popup.find('[data-addons-success-text]');
    if (successText.length && config.productTitle) {
      successText.text(config.productTitle);
    }

    $.magnificPopup.open({
      items: { src: '#product-addons-popup' },
      type: 'inline',
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: 'auto',
      closeBtnInside: false,
      closeOnContentClick: false,
      closeOnBgClick: false,
      showCloseBtn: false,
      enableEscapeKey: false,
      preloader: false,
      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-slide-bottom product-addons-mfp',
      callbacks: {
        open: function () {
          initAddonsCarousel();
        }
      }
    });
  }

  function goToCart() {
    window.location.href = config.cartUrl || '/cart';
  }

  function addMainProduct() {
    return $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      data: $form.serialize(),
      dataType: 'json'
    });
  }

  function submitMainAndOpenPopup() {
    if (!validateDeliveryDate()) {
      return false;
    }

    $addToCart.prop('disabled', true).addClass('is-adding');
    setAddToCartLabel(addingLabel);

    addMainProduct()
      .done(function () {
        $addToCart.removeClass('is-adding').addClass('is-added');
        setAddToCartLabel(addLabel);
        $addToCart.prop('disabled', false);
        updateCartCount();
        openAddonsPopup();
      })
      .fail(function (xhr) {
        $addToCart.removeClass('is-adding is-added').prop('disabled', false);
        setAddToCartLabel(addLabel);

        var data;
        try {
          data = JSON.parse(xhr.responseText);
        } catch (e) {
          data = {};
        }

        var message = data.description || data.message || 'Could not add to cart.';
        $form.after('<div class="errors qty-error product-addons-error">' + message + '</div>');
        setTimeout(function () {
          $form.next('.product-addons-error').remove();
        }, 5000);
      });

    return false;
  }

  $form.on('submit', function (evt) {
    evt.preventDefault();

    if (document.getElementById('alcoholicProduct')) {
      $('#age-check-prompt').hide();
      $('#addToCartAgeCheck').show();
      $('#prompt-background').show();

      $('#addToCartIm18')
        .off('click.productAddonsAge')
        .on('click.productAddonsAge', function () {
          $('#prompt-background').hide();
          submitMainAndOpenPopup();
        });

      return false;
    }

    return submitMainAndOpenPopup();
  });

  $(document).on('click', '.product-addons__close, .product-addons__dismiss', function (e) {
    e.preventDefault();
    if ($.magnificPopup) {
      $.magnificPopup.close();
    }
    goToCart();
  });

  $(document).on('change', '.product-addon-item__variant', function () {
    var $select = $(this);
    var $item = $select.closest('.product-addon-item');
    var $price = $item.find('[data-addon-price]');
    var $opt = $select.find('option:selected');
    var priceCents = $opt.data('price');

    if (priceCents && $price.length) {
      $price.text(formatMoney(priceCents));
    }
  });

  $(document).on('click', '[data-addon-add]', function () {
    var $btn = $(this);
    var $item = $btn.closest('.product-addon-item');
    var variantId = $item.find('.product-addon-item__variant').val();
    var $label = $btn.find('[data-addon-add-text]');
    var originalText = $label.text();

    if (!variantId || $btn.prop('disabled')) {
      return;
    }

    $btn.prop('disabled', true);
    $label.text(addingLabel);

    var payload = {
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: getAddonLineProperties()
    };

    $.ajax({
      url: '/cart/add.js',
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(payload)
    })
      .done(function () {
        updateCartCount();
        if ($.magnificPopup) {
          $.magnificPopup.close();
        }
        goToCart();
      })
      .fail(function (xhr) {
        var data;
        try {
          data = JSON.parse(xhr.responseText);
        } catch (e) {
          data = {};
        }
        $label.text(data.description || 'Error');
        setTimeout(function () {
          $label.text(originalText);
          $btn.prop('disabled', false);
        }, 2500);
      });
  });
})(jQuery);
